function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", {
  id: "simpleicons-producthunt-icon"
}, "Product Hunt icon");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentcolor",
  d: "M13.604 8.4h-3.405V12h3.405c.995 0 1.801-.806 1.801-1.801 0-.993-.805-1.799-1.801-1.799z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentcolor",
  d: "M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0zm1.604 14.4h-3.405V18H7.801V6h5.804c2.319 0 4.2 1.88 4.2 4.199 0 2.321-1.881 4.201-4.201 4.201z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "aria-labelledby": "simpleicons-producthunt-icon",
    role: "img",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/producthunt.d98dea04.svg";
export { SvgComponent as ReactComponent };